import moment from "moment"
import arrowBackIcon from "../../assets/icons/arrow-back-green.svg"
import { Button, UploadButton } from "../../components/Button"
import { Input, Label, SelectInput, TextArea } from "../../components/Form"
import "./styles.scss"
import { Avatar } from "../../components/Avatar"
import { AnswerBadge } from "../../components/AnswerBadge"
import { MessageBox } from "../../components/MessageBox"
import systemChat from "../../assets/icons/system-chat-toggle.svg"
import { Warning } from "../../components/Warning"
import { DatePicker } from "../../components/DatePicker"

const ScheduleLabel = ({ label, isRequired = true }) => {
  return (
    <div className="schedule_input_title">
      <Label>{label}</Label>
      {isRequired && <span className="required_icon">*</span>}
    </div>
  )
}

const getInputType = (row, handleChange, values) => {
  if (row?.type === "textarea" || row === "textarea") {
    return (
      <TextArea
        placeholder="Digite aqui"
        onChange={(e) =>
          handleChange("textarea", row?.formQuestionId || row?.title, e.target?.value)
        }
        value={values[row?.formQuestionId || row?.title]}
      />
    )
  } else if (row?.type === "select" || row === "select") {
    return (
      <SelectInput
        options={row?.options || []}
        isMulti
        isSearchable
        name={row?.formQuestionId || row.title}
        handleChange={(e) => handleChange("select", row?.formQuestionId || row?.title, e)}
        value={values[row?.formQuestionId || row?.title]}
      />
    )
  } else if (row?.type === "date" || row === "date") {
    return (
      <div>
        <DatePicker
          format={"DD/MM/YYYY"}
          value={
            values[row?.formQuestionId || row?.title]
              ? moment(values[row?.formQuestionId || row?.title]).format("DD/MM/YYYY")
              : null
          }
          onChange={(value) =>
            handleChange(
              "date",
              row?.formQuestionId || row?.title,
              moment(value, "DD/MM/YYYY").format("YYYY-MM-DD"),
            )
          }
        />
      </div>
    )
  } else if (row?.type === "file" || row === "file") {
    return (
      <UploadButton
        color="primary"
        variant="outline"
        label="Upload"
        name={row?.formQuestionId || row.title}
        onFileChange={(e) => handleChange("file", row?.formQuestionId || row?.title, e)}
      />
    )
  } else {
    return (
      <Input
        placeholder="Digite"
        onChange={(e) => handleChange("text", row?.formQuestionId || row?.title, e.target?.value)}
        value={values[row?.formQuestionId || row?.title]}
      />
    )
  }
}

const ScheduleFirstStep = ({
  inputList,
  handleChange,
  values,
  farmers,
  handleSelectProject,
  selectedProject,
}) => {
  const projectOptions =
    farmers && Array.isArray(farmers) && farmers[0]?.projectIds?.length > 1
      ? farmers[0]?.projectIds.map((value, index) => ({
          value: value,
          label: farmers[0].projectNames[index],
        }))
      : null

  return (
    <>
      {projectOptions && (
        <div className="schedule_left_column">
          <div className="schedule_input_container">
            <ScheduleLabel label="Selecione o projeto para qual deseja agendar um atendimento" />
            <SelectInput
              className="schedule_select_project"
              placeholder="Selecione o projeto"
              options={projectOptions}
              value={selectedProject}
              handleChange={handleSelectProject}
              isClearable={true}
            />
          </div>
        </div>
      )}
      {Array.isArray(inputList) &&
        inputList.map((item) => (
          <div className={item.col === 1 ? "schedule_left_column" : "schedule_right_column"}>
            <div
              className="schedule_row__container"
              style={
                Array.isArray(item.title)
                  ? { gridTemplateColumns: "2fr 1fr", alignItems: "center" }
                  : {}
              }>
              {Array.isArray(item.title) ? (
                item.title.map((title, idx) => (
                  <div className="schedule_input_container">
                    <ScheduleLabel label={title} isRequired={item.isRequired[idx]} />
                    {getInputType({ type: item.type[idx], title }, handleChange, values)}
                  </div>
                ))
              ) : (
                <div className="schedule_input_container">
                  <ScheduleLabel label={item.title} isRequired={item.isRequired} />
                  {getInputType(item, handleChange, values)}
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  )
}

const ScheduleSecondStep = ({ values, technicalList, handleChange, pinnedMessage }) => {
  return (
    <div className="schedule_resume__container">
      <div className="resume_answers">
        <div className="resume">
          <ScheduleLabel label="Título do atendimento" isRequired={false} />
          <span className="answer_field">{values["Dê um título para o atendimento"] || ""}</span>
        </div>
        <div className="resume">
          <ScheduleLabel label="Realização do atendimento" isRequired={false} />
          <span className="answer_field">
            {moment(values["Quando será realizado?"]).format("DD/MM/YYYY")}
          </span>
        </div>
      </div>
      <div className="tec_select">
        <ScheduleLabel label="Quem realizará o atendimento?" />
        <SelectInput
          options={technicalList}
          isSearchable
          handleChange={(value) => handleChange("select", "tec", value)}
          value={values["tec"]?.value}
        />
      </div>
      <div className="profile_resume">
        <div className="avatar_container">
          <Avatar size={64} />
        </div>
        <div className="profile_details">
          <span>{pinnedMessage[0]?.userName || pinnedMessage[0]?.username || "Produtor"}</span>
          <div className="badges_container">
            {values["3f263403-7a5e-49b4-a39f-df22e26b164a"] &&
              values["3f263403-7a5e-49b4-a39f-df22e26b164a"]
                .slice(0, 3)
                .map(({ value }) => <AnswerBadge answer={value} bold={false} />)}
          </div>
        </div>
      </div>
      {pinnedMessage.map((message) => (
        <div className="message_details">
          <MessageBox message={message} />
        </div>
      ))}
    </div>
  )
}

export const SchedulePlanScreen = ({
  inputList,
  currentStep,
  goToNextStep,
  goToPreviousStep,
  handleSaveSchedule,
  handleChange,
  values,
  pinnedMessage,
  technicalList,
  farmers,
  hasMessage,
  goToFarmerProfile,
  generateByIA,
  loadingIA,
  handleSelectProject,
  selectedProject,
  loading,
}) => {
  return (
    <div className="schedule__container">
      <div className="schedule_header">
        <div className="back-button" onClick={() => goToFarmerProfile()}>
          <img src={arrowBackIcon} alt="arrow back" />
        </div>
        <span>Agendar atendimento</span>
      </div>
      <div className="schedule_progress_bar">
        <div className="current_status" style={{ width: currentStep < 2 ? "40%" : "80%" }} />
      </div>
      <div className="schedule_subheader">
        {currentStep === 1 && (
          <Warning label="Contextualize o atendimento com o maior número de informação possível" />
        )}
        {currentStep === 2 && (
          <div className="action_button_container">
            <Button label="Voltar" variant="ghost" handleClick={goToPreviousStep} />
          </div>
        )}
        <div className="action_button_container">
          {hasMessage && (
            <div className={`button-ia ${loadingIA && "loading"}`} onClick={() => (loadingIA ? {} : generateByIA())}>
              <div className={`system-chat-toggle ${loadingIA && "loading"}`}>
                <img src={systemChat} alt="system chat" />
              </div>
              {loadingIA ? (
                <span className="loading-text">
                  Carregando informações<span className="dots">...</span>
                </span>
              ) : (
                <span>Preencher com o Agente Inteligente</span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="schedule_body_container">
        {currentStep === 1 && (
          <ScheduleFirstStep
            inputList={inputList}
            handleChange={handleChange}
            values={values}
            farmers={farmers}
            handleSelectProject={handleSelectProject}
            selectedProject={selectedProject}
          />
        )}
        {currentStep === 2 && (
          <ScheduleSecondStep
            inputList={inputList}
            handleChange={handleChange}
            values={values}
            pinnedMessage={pinnedMessage}
            technicalList={technicalList}
          />
        )}
      </div>
      <div className="schedule_footer">
        <Button
          label={currentStep === 1 ? "Seguir" : "Finalizar agendamento"}
          isDisabled={loading}
          handleClick={() => (currentStep === 1 ? goToNextStep() : handleSaveSchedule())}
        />
      </div>
    </div>
  )
}
